import { render } from "./property-tax-history.vue?vue&type=template&id=c0cc4eea"
import script from "./property-tax-history.js?vue&type=script&lang=js"
export * from "./property-tax-history.js?vue&type=script&lang=js"

import "./property-tax-history.vue?vue&type=style&index=0&id=c0cc4eea&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__